module.exports = __webpack_public_path__ + "img/packages.884bb5c3.png";